var map = {
  "./cs.json": [
    "sT",
    [
      "i1"
    ]
  ],
  "./en.json": [
    "lUP",
    [
      "nt"
    ]
  ],
  "./pl.json": [
    "rT",
    [
      "99r"
    ]
  ],
  "./ru.json": [
    "piU",
    [
      "rh"
    ]
  ],
  "./tr.json": [
    "snB",
    [
      "ifw"
    ]
  ],
  "./ja.json": [
    "u0p",
    [
      "wn"
    ]
  ],
  "./zh.json": [
    "vA",
    [
      56
    ]
  ],
  "./pt-br.json": [
    "Nde",
    [
      "b2k"
    ]
  ],
  "./de.json": [
    "r5D",
    [
      99
    ]
  ],
  "./es.json": [
    "JY",
    [
      "jy"
    ]
  ],
  "./fr.json": [
    "V9E",
    [
      "3k"
    ]
  ],
  "./it.json": [
    "Nt",
    [
      "b4"
    ]
  ],
  "./ko.json": [
    "GmW",
    [
      "k7"
    ]
  ],
  "./pt.json": [
    "Hm",
    [
      "pi"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "uT";
module.exports = __rspack_async_context;
